export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I’m a passionate Full Stack Laravel Developer focused on creating efficient, scalable, and user-friendly web applications. I enjoy solving complex problems, building reliable backend systems, and continuously learning new technologies to deliver better digital experiences.
          </p>
          <p className="hero--section-description">
            With a strong foundation in Laravel, JavaScript, and modern frontend frameworks, I specialize in developing secure and high-performance applications. I thrive in collaborative environments and am committed to writing clean, maintainable code that meets both user needs and business goals.
          </p>
        </div>
      </div>
    </section>
  );
}
